// extracted by mini-css-extract-plugin
export default {"cardDetailsLoading":"CardModal_cardDetailsLoading__MqrE9"};